window.addEventListener("load",function(){document.querySelectorAll('a[href^="#"]').forEach(function(t){t.addEventListener("click",function(t){t.preventDefault();var o=document.querySelector(this.hash);o&&window.scrollTo({top:o.offsetTop-40,behavior:"smooth"})})}),document.querySelectorAll(".open-chat, .btn-contact").forEach(function(t){t.addEventListener("click",function(){console.log("open-chat clicado");var t=document.getElementById("chat-button");t?(t.onload=function(){var o=t.contentDocument||t.contentWindow.document,n=setInterval(function(){var t=o.querySelector("#gorgias-chat-messenger-button");t&&(console.log("Bot\xf3n encontrado en iframe, simulando clic"),t.click(),clearInterval(n))},100)},(t.contentDocument||"complete"===t.contentWindow.document.readyState)&&t.onload()):console.error('Iframe con ID "chat-button" no encontrado')})})});
/*window.addEventListener('load', function() {
    // Enlaces que comienzan con #
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            var target = document.querySelector(this.hash);
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 40,
                    behavior: 'smooth'
                });
            }
        });
    });

    // Detectar clic en .open-chat o .btn-contact
    document.querySelectorAll('.open-chat, .btn-contact').forEach(function(button) {
        button.addEventListener('click', function() {
            console.log('open-chat clicado');

            // Obtener iframe por su ID
            var iframe = document.getElementById('chat-button');
            if (iframe) {
                iframe.onload = function() {
                    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

                    var checkButton = setInterval(function() {
                        var button = iframeDocument.querySelector('#gorgias-chat-messenger-button');
                        if (button) {
                            console.log('Botón encontrado en iframe, simulando clic');
                            button.click();
                            clearInterval(checkButton);
                        }
                    }, 100);
                };

                if (iframe.contentDocument || iframe.contentWindow.document.readyState === 'complete') {
                    iframe.onload();
                }
            } else {
                console.error('Iframe con ID "chat-button" no encontrado');
            }
        });
    });
});*/
